module.exports = __webpack_public_path__ + "static/media/checkmark-gray.cc3f256d.svg";